/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Vertical_Text_Aria_LabelInputs */

const en_input_position_vertical_text_aria_label = /** @type {(inputs: Input_Position_Vertical_Text_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to horizontal text`)
};

const fr_input_position_vertical_text_aria_label = /** @type {(inputs: Input_Position_Vertical_Text_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer vers le texte horizontal`)
};

const de_input_position_vertical_text_aria_label = /** @type {(inputs: Input_Position_Vertical_Text_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf horizontalen Text umschalten`)
};

const it_input_position_vertical_text_aria_label = /** @type {(inputs: Input_Position_Vertical_Text_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passa al testo orizzontale`)
};

const ru_input_position_vertical_text_aria_label = /** @type {(inputs: Input_Position_Vertical_Text_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключиться на горизонтальный текст`)
};

const es_input_position_vertical_text_aria_label = /** @type {(inputs: Input_Position_Vertical_Text_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar a texto horizontal`)
};

const zh_cn2_input_position_vertical_text_aria_label = /** @type {(inputs: Input_Position_Vertical_Text_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换到横屏模式`)
};

const ja_input_position_vertical_text_aria_label = /** @type {(inputs: Input_Position_Vertical_Text_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`横書きテキストに切り替える`)
};

const hi_input_position_vertical_text_aria_label = /** @type {(inputs: Input_Position_Vertical_Text_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्षैतिज पाठ पर स्विच करें`)
};

const pt_pt2_input_position_vertical_text_aria_label = /** @type {(inputs: Input_Position_Vertical_Text_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar para texto horizontal`)
};

/**
* | output |
* | --- |
* | "Switch to horizontal text" |
*
* @param {Input_Position_Vertical_Text_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_vertical_text_aria_label = /** @type {((inputs?: Input_Position_Vertical_Text_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Vertical_Text_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_vertical_text_aria_label(inputs)
	if (locale === "de") return de_input_position_vertical_text_aria_label(inputs)
	if (locale === "it") return it_input_position_vertical_text_aria_label(inputs)
	if (locale === "ru") return ru_input_position_vertical_text_aria_label(inputs)
	if (locale === "es") return es_input_position_vertical_text_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_vertical_text_aria_label(inputs)
	if (locale === "ja") return ja_input_position_vertical_text_aria_label(inputs)
	if (locale === "hi") return hi_input_position_vertical_text_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_vertical_text_aria_label(inputs)
	return en_input_position_vertical_text_aria_label(inputs)
});